import { GameHudOnboarding, ONBOARDING_OVERLAYS } from './GameHudOnboarding';

export class SceneOnboardingPlugin extends Phaser.Plugins.ScenePlugin {
  constructor(scene, pluginManager) {
    super(scene, pluginManager);
    this.scene.events.on('shutdown', this._handleSceneShutdown, this);
  }

  showOnboarding(type, config) {
    this.closeOnboarding();
    this._onboarding = { type, config };
    this._onboardingOverlay = new ONBOARDING_OVERLAYS[type](this.scene, config);
    this._onboardingOverlay.depth = 100;
  }

  triggerOnboarding(config) {
    this._onboarding = { config };
    if (!this._onboardingOverlay) this._onboardingOverlay = new GameHudOnboarding(this.scene);
    this._onboardingOverlay.showOnboarding(config);
    this._onboardingOverlay.depth = 100;
  }

  closeOnboarding(config) {
    if (this._onboardingOverlay) {
      this._onboardingOverlay.closeOnboarding(config);
      this._onboardingOverlay = null;
    }
  }

  _handleSceneShutdown() {
    if (this._onboardingOverlay) {
      this._onboardingOverlay.destroy();
      this._onboardingOverlay = null;
    }
  }
}
